import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for handling Back to Top functionality
 */
export default class BackToTop extends MessageBus {
  /**
   * Constructor function for the BackToTop class.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    this.element = element;
    this.init();
  }

  /**
   * Initializes the view by calling the functions to
   * create DOM references, setup event handlers, and
   * then create the event listeners.
   * @returns {object} BackToTop A reference to the current instance of the class
   * @chainable
   */
  init() {
    this.cacheDomReferences().setupHandlers().enable();
    return this;
  }

  /**
   * Cache DOM References
   * @returns {object} BackToTop A reference to the current instance of the class
   * @chainable
   */
  cacheDomReferences() {
    this.backToTopBtn = this.element;
    this.toTopButton = this.element.querySelector(CLASS_NAMES.TO_TOP_BUTTON);
    this.scrollTarget = document.querySelector(`#${CLASS_NAMES.SCROLL_TARGET}`);
    return this;
  }

  /**
   * Setup event handlers
   * @returns {object} BackToTop A reference to the current instance of the class
   * @chainable
   */
  setupHandlers() {
    this.handleScroll = this.handleScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.scrollToSection = this.scrollToSection.bind(this);
    return this;
  }

  /**
   * Enable event listeners
   * @returns {object} BackToTop A reference to the current instance of the class
   * @chainable
   */
  enable() {
    // if (!this.backToTopBtn || !this.scrollTarget) return this;

    window.addEventListener(EVENTS.SCROLL, this.handleScroll);
    this.toTopButton?.addEventListener(EVENTS.CLICK, this.scrollToTop);
    this.backToTopBtn?.addEventListener(EVENTS.CLICK, this.scrollToSection);
    return this;
  }

  /**
   * Handles the scroll event
   */
  handleScroll() {
    if (!this.scrollTarget) {
      return;
    }

    if (window.scrollY > this.scrollTarget.offsetTop + 300) {
      this.backToTopBtn.classList.add('show');
    } else {
      this.backToTopBtn.classList.remove('show');
    }
  }

  /**
   * Scroll to the top of the page
   * @returns {object} BackToTop A reference to the current instance of the class
   */
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return this;
  }

  /**
   * Scroll to the introduction section
   * @returns {object} BackToTop A reference to the current instance of the class
   */
  scrollToSection() {
    if (!this.scrollTarget) {
      return this;
    }
    window.scrollTo({
      top: this.scrollTarget.offsetTop - 70,
      behavior: 'smooth'
    });
    return this;
  }
}
